module.exports = __webpack_public_path__ + "static/postCard-caa1a820b71ccdd0353797fbbdc17270.png";